import { createURL } from '@sm/utils';
import { US_GEO_PAGES, WeightedElement } from './constants';
import { APP_LINKS, UT_SOURCE_PATHS } from '~app/components/constants';

/**
 * Using a weighted distribution, select and return the page that the target element falls on
 *
 * @param weightedElements object of pages
 * @param target value within distribution range, use a random number [0, 1) if weighted distribution adds up to 1
 * @returns Selected page object to serve
 */
export function WeightedElementSelector(weightedElements: WeightedElement[], target: number): WeightedElement {
  let cumulativeWeight = 0.0;
  let selectedPage: WeightedElement = US_GEO_PAGES[0];
  weightedElements.every(element => {
    cumulativeWeight += element.weight;
    if (target < cumulativeWeight) {
      selectedPage = element;
      return false;
    }
    return true;
  });
  return selectedPage;
}

export function checkWeightsEqualToOne(weightedElements: WeightedElement[]): boolean {
  let total = 0.0;
  weightedElements.forEach(element => {
    total += element.weight;
  });
  if (Number(total.toFixed(3)) === 1) return true;
  return false;
}

// Function to determine the correct CTA link based on platform and ctaType
export const getRewardsCTALink = (
  ctaType: 'taker' | 'creator',
  utSource: string,
  utSource2: string,
  utSource3: string,
  ctaText: string,
  userAgent: string
): string => {
  const urlParams = {
    ut_source: utSource,
    ut_source2: utSource2,
    ut_source3: utSource3,
    ut_ctatext: ctaText,
  };

  const isMobilePath = [UT_SOURCE_PATHS?.OPTIONAL_PATH_MAPP1, UT_SOURCE_PATHS?.OPTIONAL_PATH_MAPP2].includes(utSource2);

  if (ctaType === 'creator') {
    return createURL('/sign-up', urlParams);
  }

  const isAndroid = /android/i.test(userAgent);
  const isIOS = /iPad|iPhone|iPod/.test(userAgent);

  if (isMobilePath && isAndroid) {
    return APP_LINKS.android;
  }

  if (isMobilePath && isIOS) {
    return APP_LINKS.ios;
  }
  // Fallback for other cases (non-mobile)
  return createURL('/rewards', urlParams);
};
